import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { listSettingsFields } from "../models/fieldSettings";
import {
  APP_TYPE,
  PS_WEB,
  checkToday,
  getLs,
  momentDate,
  setLs,
  upperCase,
} from "../utils";
import PsContext from "./index";

import { SpinLoading } from "antd-mobile";
import JWT from "expo-jwt";

import Snackbar from "@mui/material/Snackbar";
import { Backdrop, CircularProgress } from "@mui/material";

const PsContextProvider = (props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const breakpoint = 620;

  const token = "21R91541sD5411H0G5";

  useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
       the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
       effect to only run when the component mounts, and not each time it updates.
       We only want the listener to be added once */
  }, []);

  const isMobileView = () => (windowWidth < breakpoint ? true : false);

  const checkUserLogged = () => {
    return getLs("mcoa_logged") || "no";
  };

  const checkUserMobilePassword = () => {
    return getLs("mcoa_mob_pass") || "";
  };

  const checkMobileUserId = () => {
    return getLs("mcoa_mob_uuid") || "";
  };

  const getAdminUser = () => {
    return getLs("mcoa_user_data") && getLs("mcoa_user_data") !== "undefined"
      ? JSON.parse(getLs("mcoa_user_data"))
      : [];
  };

  const getAdminCompany = () => {
    return getLs("mcoa_company_data") &&
      getLs("mcoa_company_data") !== "undefined"
      ? JSON.parse(getLs("mcoa_company_data"))
      : [];
  };

  const getAdminApi = () => {
    return getLs("mcoa_api") || "";
  };

  const getSettings = () => {
    /*return getLs("madm_settings") && getLs("madm_settings") !== "undefined"
      ? JSON.parse(getLs("madm_settings"))
      : [];*/
    try {
      let set = getLs("adm_settings");
      if (set && set !== undefined) {
        if (!set.includes("{")) {
          let decoded = JWT.decode(set, PS_WEB);
          setSettings(decoded);
          return decoded;
        }
        return [];
      } else {
        setSettings([]);
        return [];
      }
    } catch (er) {
      localStorage.clear();
      console.log(er);
      return [];
    }
  };

  const getAcyear = () => {
    return getLs("adm_acyear_cur") && getLs("adm_acyear_cur") !== "undefined"
      ? JSON.parse(getLs("adm_acyear_cur"))
      : [];
  };

  const getPermissions = () => {
    return getLs("madm_user_permissions") &&
      getLs("madm_user_permissions") !== "undefined"
      ? JSON.parse(getLs("madm_user_permissions"))
      : [];
  };

  const getCashbook = () => {
    return getLs("madm_user_cashbook") &&
      getLs("madm_user_cashbook") !== "undefined"
      ? JSON.parse(getLs("madm_user_cashbook"))
      : [];
  };

  const getDbPostFix = () => {
    return getLs("mdb_postfix") && getLs("mdb_postfix") !== "undefined"
      ? getLs("mdb_postfix")
      : null;
  };

  const [state, setState] = useState([]);

  const [logged, setLogged] = useState(checkUserLogged());

  const [mobilePass, setMobilePass] = useState(checkUserMobilePassword());
  const [mobileUserId, setMobileUserId] = useState(checkMobileUserId());

  const [user, setUser] = useState(getAdminUser());
  const [api, setApi] = useState(getAdminApi());

  const [backgroundProcess, setBackgroundProcess] = useState(false);

  //const [settings, setSettings] = useState(getSettings());
  const [settingsUpdated, setSettingsUpdate] = useState(false);
  const [settings, setSettings] = useState([]);
  const [acyear, setSAcyear] = useState(getAcyear());

  const [accessPermissions, setAccessPermissions] = useState(getPermissions());
  const [cashbook, setCashbook] = useState(getCashbook());

  const [selectedAdmissionYear, setadmissionYear] = useState("2022");
  const [dbPostfix, setDbPostfix] = useState(getDbPostFix());

  const [loader, setLoader] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");

  useEffect(() => {
    if (settings) forceUpdate();
  }, [settings]);

  useEffect(() => {
    getSettings();
  }, [settingsUpdated]);

  const saveLogin = (user, api, permissions = [], cb = [], mobPass = "") => {
    /*var now = new Date();
		var minutes = 1;
		now.setTime(now.getTime() + (minutes * 60 * 1000));*/

    setLs("mcoa_user_data", JSON.stringify(user));
    setUser(user);

    setLs("mcoa_api", api);
    setApi(api);

    setLs("madm_user_permissions", JSON.stringify(permissions));
    setAccessPermissions(permissions);

    setLs("madm_user_cashbook", JSON.stringify(cb));
    setCashbook(cb);

    //setLs('mat_logged', 'yes');
    //setLogged('yes');
  };

  const logout = (withoutPostFix = false) => {
    setLs("mcoa_user_data", false);
    setUser([]);
    setSAcyear([]);
    //setLs("mcoa_api", "");
    setLs("adm_acyear_cur", false);
    //setApi(null);
    setLs("madm_user_permissions", "");
    setAccessPermissions([]);
    setCashbook([]);
    setLs("mcoa_logged", "no");
    setLogged("no");
    if (APP_TYPE == "SAAS" && !withoutPostFix) {
      setDbPostfix(null);
    }
    let mob_set = getLs("adm_settings");
    let mob_api = getLs("mcoa_api");
    localStorage.clear();
    setLs("adm_settings", mob_set);
    setLs("mcoa_api", mob_api);
    sessionStorage.setItem("mob_stu_fee_pop_pending", "");
  };

  const updateDbPostfix = (v) => {
    setLs("mdb_postfix", v);
    setDbPostfix(v);
  };

  const decode = (v) => {
    try {
      return JWT.decode(v, PS_WEB);
    } catch (er) {
      console.log(er);
      return [];
    }
  };

  const getDecodeApi = () => {
    // let decoded = jwt.decode(api, token);
    // return decoded;
  };

  const setEncodeApi = (decoded) => {
    /*let encoded = jwt.encode(decoded, token);
    axios.defaults.headers.common["Api-Token"] = encoded;
    setLs("coa_api", encoded);
    setApi(api);*/
  };

  const updateApi = (encoded) => {
    //let encoded = jwt.encode(decoded, token);
    axios.defaults.headers.common["Api-Token"] = encoded;
    setLs("coa_api", encoded);
    setApi(encoded);
    forceUpdate();
    if (encoded !== null) loadSettings();
  };

  const updateUser = (user) => {
    setLs("mcoa_user_data", JSON.stringify(user));
    setUser(user);
  };

  const updateLogged = () => {
    setLs("mcoa_logged", "yes");
    setLogged("yes");
  };

  const loadSettings = () => {
    listSettingsFields("1", true).then((res) => {
      if (res.permissions) {
        setLs("madm_user_permissions", JSON.stringify(res.permissions));
        setAccessPermissions(res.permissions);
      }
      if (res.data) {
        setLs("adm_settings", res.data.trim());
        setSettingsUpdate(!settingsUpdated);
      }
    });
  };

  /*   const settingValue = (key) => {
    let m = settings && settings.find((item) => item.field_name == key);
    return m && m.field_name ? m.field_value : false;
  }; */

  const settingValue = (key, college_uuid) => {
    let m =
      settings &&
      settings.find(
        (item) => item.field_name == key && item.college_uuid == college_uuid
      );
    return m && m.field_name ? m.field_value : false;
  };

  const updateAcyear = (v) => {
    setSAcyear(v);
    setLs("adm_acyear_cur", JSON.stringify(v));
  };

  const updateMobileUserId = (v, name = false) => {
    setMobileUserId(v);
    setLs("mcoa_mob_uuid", v);
    if (name) setStorage("mcob_emp_name", name);
  };

  const updateMobilePassword = (v) => {
    setLs("mcoa_mob_pass", v);
    setMobilePass(v);
  };

  const setStorage = (storageName, storageValue, stDt = false) => {
    if (stDt) {
      let v = { dt: stDt, data: storageValue };
      setLs(storageName, JSON.stringify(v));
    } else {
      setLs(storageName, storageValue);
    }
  };

  const getStorageByDate = (storageName) => {
    let m = getStorage(storageName);
    if (m && m.length > 0) {
      m = JSON.parse(m);
      if (m.dt && checkToday(m.dt) && m.data) {
        return m.data;
      }
    }
    return false;
  };

  const getStorage = (storageName, stDt = false) => {
    return getLs(storageName); /* && getLs(storageName) !== "undefined"
      ? getLs(storageName)
      : null;*/
  };

  const allowedAccess = (module, action) => {
    let permissions = accessPermissions;
    try {
      if (upperCase(user.role) == "DEV") return true;

      /* if (props.roleGroup && props.roleGroup.length > 0) {
        let allowedRoleGroups = findCommonElement(
          permissions.map((item) => item.role_group),
          props.roleGroup
        );
        return allowedRoleGroups;
      }*/

      if (!module || !action) return false;

      if (upperCase(module) == "ANY" && upperCase(action) == "ANY") return true;

      let moduleExist = permissions.filter(
        (item) => upperCase(item.module) == upperCase(module)
      );

      if (moduleExist.length < 1) return false;

      let allowed = moduleExist.find(
        (item) => upperCase(item.action_name) == upperCase(action)
      );

      return allowed ? true : false;
    } catch (er) {
      return false;
    }
  };

  const forceUpdate = useCallback(() => setState({}), []);

  return (
    <PsContext.Provider
      value={{
        state: state,
        logged: logged,
        user: user,
        acyear: acyear,
        api: api,
        saveLogin: saveLogin,
        updateUser: updateUser,
        updateLogged: updateLogged,
        setBackgroundProcess: setBackgroundProcess,
        backgroundProcess: backgroundProcess,
        logout: logout,
        loadSettings: loadSettings,
        settingValue: settingValue,
        selectedAdmissionYear: selectedAdmissionYear,
        updateAcyear: updateAcyear,
        accessPermissions: accessPermissions,
        allowedAccess: allowedAccess,
        cashbook: cashbook,
        isMobileView: isMobileView,
        mobilePass: mobilePass,
        mobileUserId: mobileUserId,
        updateMobileUserId: updateMobileUserId,
        updateMobilePassword: updateMobilePassword,
        setLoader: setLoader,
        setStorage: setStorage,
        getStorage: getStorage,
        decode: decode,
        getDecodeApi: getDecodeApi,
        setEncodeApi: setEncodeApi,
        dbPostfix: dbPostfix,
        updateDbPostfix: updateDbPostfix,
        updateApi: updateApi,
        getStorageByDate: getStorageByDate,
        setAlertMsg: setAlertMsg,
      }}
    >
      {/*loader && (
        <div className="ps__loader">
          <div className="ps__loader__body">
            <div className="ps__loader__content">
              
              <center>
                <SpinLoading
                  color="currentColor"
                  style={{ "--size": "32px" }}
                />
                <br />
                Please Wait
              </center>
            </div>
          </div>
        </div>
      )*/}

      {props.children}

      <Snackbar
        open={alertMsg && alertMsg.length > 0}
        onClose={(e) => setAlertMsg("")}
        message={alertMsg || "Message"}
        autoHideDuration={2500}
        anchorOrigin={{ horizontal: "center", vertical: "middle" }}
      />

      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 999 })}
        open={loader}
        onClick={(e) => {}}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </PsContext.Provider>
  );
};

export default PsContextProvider;
